/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TeacherInfoInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class TeacherInfoApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'TeacherInfos');
  }

  checkUnique(userId: number, prop: string, publicKey: string): Observable<boolean> {
    const path = 'checkUnique';
    const body = {
      key: userId,
      property: prop,
      value: publicKey,
    };

    return this.post(path, undefined, body);
  }

  create(data: object): Observable<TeacherInfoInterface> {
    const path = '';
    return this.post(path, undefined, data);
  }

  updateAttributes(id: number, data: any): Observable<TeacherInfoInterface> {
    const path = `${id}`;
    return this.patch(path, undefined, data);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete(path).pipe(map(() => true));
  }
}
